import { sortBy } from 'lodash';
import { useTranslation } from 'react-i18next';

import {
  ASC,
  DESC,
  PAGE_PRODUCTS_CATEGORY,
  PRODUCTS_LOCAL_SORT_CUSTOMER_PRICE,
  PRODUCTS_LOCAL_SORT_PUBLIC_PRICE,
  PRODUCTS_LOCAL_SORT_STOCK,
} from '@/common/constants';
import { useAuth } from '@/common/contexts/AuthContext';
import getStockStatus from '@/ebat/components/blocks/Common/Stocks/getStockStatus';

const priceSorter = (data, propertiesPath, direction) =>
  sortBy(data, (datum) => {
    const propertiesArray = propertiesPath.split('.');
    const value = propertiesArray.reduce(
      (accu, property) => accu && accu[property],
      datum,
    );

    if (Number.isNaN(value)) {
      return 0;
    }
    return value * (direction === DESC ? -1 : 1);
  });

const stockSorter = (data, propertiesPath, direction) => {
  const statusWeights = [
    'unknown',
    'nodis',
    'info',
    'warning',
    'delay',
    'success',
  ];
  return sortBy(data, (datum) => {
    const minDelay =
      datum.price_and_stock?.stocks?.reduce(
        (delay, stock) =>
          stock.quantity > 0 && stock.delay < delay ? stock.delay : delay,
        72,
      ) ?? 72;
    const status = getStockStatus(
      datum.price_and_stock?.stock_status,
      datum.company_availability,
      minDelay,
    );

    return (statusWeights.indexOf(status) + 1) * (direction === DESC ? 1 : -1);
  });
};

const useLocalSorts = (pageName, disabledPrice, disabledStocks) => {
  const { t } = useTranslation();
  const { isShowNetPrice } = useAuth();
  let localSorts = [];

  if (pageName === PAGE_PRODUCTS_CATEGORY) {
    localSorts = [
      {
        code: PRODUCTS_LOCAL_SORT_PUBLIC_PRICE,
        label: t('common:messages:sort.public_price'),
        sorter: priceSorter,
        propertiesPath: 'price_and_stock.price.public_price',
        directions: [ASC, DESC],
        active: false,
        direction: null,
        disabled: disabledPrice,
      },
      {
        code: PRODUCTS_LOCAL_SORT_STOCK,
        label: t('common:messages:sort.stock'),
        sorter: stockSorter,
        propertiesPath: '',
        directions: [ASC, DESC],
        active: false,
        direction: null,
        disabled: disabledStocks,
      },
    ];

    if (isShowNetPrice) {
      localSorts = [
        {
          code: PRODUCTS_LOCAL_SORT_CUSTOMER_PRICE,
          label: t('common:messages:sort.customer_price'),
          sorter: priceSorter,
          propertiesPath: 'price_and_stock.price.customer_price',
          directions: [ASC, DESC],
          active: false,
          direction: null,
          disabled: disabledPrice,
        },
        ...localSorts,
      ];
    }
  }

  return { localSorts };
};

export default useLocalSorts;
